/** @jsx jsx */
import { useMemo } from 'react';
import { jsx } from 'theme-ui';
import { CustomSelectField } from './CustomSelectField';
export var CountryField = function (_a) {
    var id = _a.id, variant = _a.variant, className = _a.className, value = _a.value, onChange = _a.onChange, global = _a.global;
    var filteredCountries = useMemo(function () { return (global ? countries : countries.filter(function (x) { return x.local; })); }, [global]);
    return (jsx(CustomSelectField, { id: id, variant: variant, className: className, options: filteredCountries, value: value, onChange: onChange, placeholder: "Select..." }));
};
export function countryAlpha2toNumeric(alpha2) {
    var _a;
    return ((_a = countries.find(function (x) { return x.value === alpha2; })) === null || _a === void 0 ? void 0 : _a.numeric) || null;
}
var countries = [
    { value: 'AF', numeric: '004', text: 'Afghanistan' },
    { value: 'AX', numeric: '248', text: 'Åland Islands' },
    { value: 'AL', numeric: '008', text: 'Albania' },
    { value: 'DZ', numeric: '012', text: 'Algeria' },
    { value: 'AS', numeric: '016', text: 'American Samoa' },
    { value: 'AD', numeric: '020', text: 'Andorra' },
    { value: 'AO', numeric: '024', text: 'Angola' },
    { value: 'AI', numeric: '660', text: 'Anguilla' },
    { value: 'AQ', numeric: '010', text: 'Antarctica' },
    { value: 'AG', numeric: '028', text: 'Antigua and Barbuda' },
    { value: 'AR', numeric: '032', text: 'Argentina' },
    { value: 'AM', numeric: '051', text: 'Armenia' },
    { value: 'AW', numeric: '533', text: 'Aruba' },
    { value: 'AU', numeric: '036', text: 'Australia' },
    { value: 'AT', numeric: '040', text: 'Austria' },
    { value: 'AZ', numeric: '031', text: 'Azerbaijan' },
    { value: 'BS', numeric: '044', text: 'Bahamas' },
    { value: 'BH', numeric: '048', text: 'Bahrain' },
    { value: 'BD', numeric: '050', text: 'Bangladesh' },
    { value: 'BB', numeric: '052', text: 'Barbados' },
    { value: 'BY', numeric: '112', text: 'Belarus' },
    { value: 'BE', numeric: '056', text: 'Belgium' },
    { value: 'BZ', numeric: '084', text: 'Belize' },
    { value: 'BJ', numeric: '204', text: 'Benin' },
    { value: 'BM', numeric: '060', text: 'Bermuda' },
    { value: 'BT', numeric: '064', text: 'Bhutan' },
    { value: 'BO', numeric: '068', text: 'Bolivia' },
    { value: 'BQ', numeric: '535', text: 'Bonaire, Sint Eustatius and Saba' },
    { value: 'BA', numeric: '070', text: 'Bosnia and Herzegovina' },
    { value: 'BW', numeric: '072', text: 'Botswana' },
    { value: 'BV', numeric: '074', text: 'Bouvet Island' },
    { value: 'BR', numeric: '076', text: 'Brazil' },
    { value: 'IO', numeric: '086', text: 'British Indian Ocean Territory' },
    { value: 'BN', numeric: '096', text: 'Brunei Darussalam' },
    { value: 'BG', numeric: '100', text: 'Bulgaria' },
    { value: 'BF', numeric: '854', text: 'Burkina Faso' },
    { value: 'BI', numeric: '108', text: 'Burundi' },
    { value: 'CV', numeric: '132', text: 'Cabo Verde' },
    { value: 'KH', numeric: '116', text: 'Cambodia' },
    { value: 'CM', numeric: '120', text: 'Cameroon' },
    { value: 'CA', numeric: '124', text: 'Canada' },
    { value: 'KY', numeric: '136', text: 'Cayman Islands' },
    { value: 'CF', numeric: '140', text: 'Central African Republic' },
    { value: 'TD', numeric: '148', text: 'Chad' },
    { value: 'CL', numeric: '152', text: 'Chile' },
    { value: 'CN', numeric: '156', text: 'China' },
    { value: 'CX', numeric: '162', text: 'Christmas Island' },
    { value: 'CC', numeric: '166', text: 'Cocos Islands' },
    { value: 'CO', numeric: '170', text: 'Colombia' },
    { value: 'KM', numeric: '174', text: 'Comoros' },
    { value: 'CG', numeric: '178', text: 'Congo' },
    { value: 'CD', numeric: '180', text: 'Congo' },
    { value: 'CK', numeric: '184', text: 'Cook Islands' },
    { value: 'CR', numeric: '188', text: 'Costa Rica' },
    { value: 'CI', numeric: '384', text: "Côte d'Ivoire" },
    { value: 'HR', numeric: '191', text: 'Croatia' },
    { value: 'CU', numeric: '192', text: 'Cuba' },
    { value: 'CW', numeric: '531', text: 'Curaçao' },
    { value: 'CY', numeric: '196', text: 'Cyprus' },
    { value: 'CZ', numeric: '203', text: 'Czech Republic' },
    { value: 'DK', numeric: '208', text: 'Denmark' },
    { value: 'DJ', numeric: '262', text: 'Djibouti' },
    { value: 'DM', numeric: '212', text: 'Dominica' },
    { value: 'DO', numeric: '214', text: 'Dominican Republic' },
    { value: 'EC', numeric: '218', text: 'Ecuador' },
    { value: 'EG', numeric: '818', text: 'Egypt' },
    { value: 'SV', numeric: '222', text: 'El Salvador' },
    { value: 'GQ', numeric: '226', text: 'Equatorial Guinea' },
    { value: 'ER', numeric: '232', text: 'Eritrea' },
    { value: 'EE', numeric: '233', text: 'Estonia' },
    { value: 'ET', numeric: '231', text: 'Ethiopia' },
    { value: 'FK', numeric: '238', text: 'Falkland Islands' },
    { value: 'FO', numeric: '234', text: 'Faroe Islands' },
    { value: 'FJ', numeric: '242', text: 'Fiji' },
    { value: 'FI', numeric: '246', text: 'Finland' },
    { value: 'FR', numeric: '250', text: 'France' },
    { value: 'GF', numeric: '254', text: 'French Guiana' },
    { value: 'PF', numeric: '258', text: 'French Polynesia' },
    { value: 'TF', numeric: '260', text: 'French Southern Territories' },
    { value: 'GA', numeric: '266', text: 'Gabon' },
    { value: 'GM', numeric: '270', text: 'Gambia' },
    { value: 'GE', numeric: '268', text: 'Georgia' },
    { value: 'DE', numeric: '276', text: 'Germany' },
    { value: 'GH', numeric: '288', text: 'Ghana' },
    { value: 'GI', numeric: '292', text: 'Gibraltar' },
    { value: 'GR', numeric: '300', text: 'Greece' },
    { value: 'GL', numeric: '304', text: 'Greenland' },
    { value: 'GD', numeric: '308', text: 'Grenada' },
    { value: 'GP', numeric: '312', text: 'Guadeloupe' },
    { value: 'GU', numeric: '316', text: 'Guam' },
    { value: 'GT', numeric: '320', text: 'Guatemala' },
    { value: 'GG', numeric: '831', text: 'Guernsey', local: true },
    { value: 'GN', numeric: '324', text: 'Guinea' },
    { value: 'GW', numeric: '624', text: 'Guinea-Bissau' },
    { value: 'GY', numeric: '328', text: 'Guyana' },
    { value: 'HT', numeric: '332', text: 'Haiti' },
    { value: 'HM', numeric: '334', text: 'Heard Island and McDonald Islands' },
    { value: 'VA', numeric: '336', text: 'Holy See' },
    { value: 'HN', numeric: '340', text: 'Honduras' },
    { value: 'HK', numeric: '344', text: 'Hong Kong' },
    { value: 'HU', numeric: '348', text: 'Hungary' },
    { value: 'IS', numeric: '352', text: 'Iceland' },
    { value: 'IN', numeric: '356', text: 'India' },
    { value: 'ID', numeric: '360', text: 'Indonesia' },
    { value: 'IR', numeric: '364', text: 'Islamic Republic of Iran' },
    { value: 'IQ', numeric: '368', text: 'Iraq' },
    { value: 'IE', numeric: '372', text: 'Ireland' },
    { value: 'IM', numeric: '833', text: 'Isle of Man' },
    { value: 'IL', numeric: '376', text: 'Israel' },
    { value: 'IT', numeric: '380', text: 'Italy' },
    { value: 'JM', numeric: '388', text: 'Jamaica' },
    { value: 'JP', numeric: '392', text: 'Japan' },
    { value: 'JE', numeric: '832', text: 'Jersey', local: true },
    { value: 'JO', numeric: '400', text: 'Jordan' },
    { value: 'KZ', numeric: '398', text: 'Kazakhstan' },
    { value: 'KE', numeric: '404', text: 'Kenya' },
    { value: 'KI', numeric: '296', text: 'Kiribati' },
    {
        value: 'KP',
        numeric: '408',
        text: "Democratic People's Republic of Korea",
    },
    { value: 'KR', numeric: '410', text: 'Republic of Korea' },
    { value: 'KW', numeric: '414', text: 'Kuwait' },
    { value: 'KG', numeric: '417', text: 'Kyrgyzstan' },
    { value: 'LA', numeric: '418', text: "Lao People's Democratic Republic" },
    { value: 'LV', numeric: '428', text: 'Latvia' },
    { value: 'LB', numeric: '422', text: 'Lebanon' },
    { value: 'LS', numeric: '426', text: 'Lesotho' },
    { value: 'LR', numeric: '430', text: 'Liberia' },
    { value: 'LY', numeric: '434', text: 'Libya' },
    { value: 'LI', numeric: '438', text: 'Liechtenstein' },
    { value: 'LT', numeric: '440', text: 'Lithuania' },
    { value: 'LU', numeric: '442', text: 'Luxembourg' },
    { value: 'MO', numeric: '446', text: 'Macao' },
    { value: 'MK', numeric: '807', text: 'Macedonia' },
    { value: 'MG', numeric: '450', text: 'Madagascar' },
    { value: 'MW', numeric: '454', text: 'Malawi' },
    { value: 'MY', numeric: '458', text: 'Malaysia' },
    { value: 'MV', numeric: '462', text: 'Maldives' },
    { value: 'ML', numeric: '466', text: 'Mali' },
    { value: 'MT', numeric: '470', text: 'Malta' },
    { value: 'MH', numeric: '584', text: 'Marshall Islands' },
    { value: 'MQ', numeric: '474', text: 'Martinique' },
    { value: 'MR', numeric: '478', text: 'Mauritania' },
    { value: 'MU', numeric: '480', text: 'Mauritius' },
    { value: 'YT', numeric: '175', text: 'Mayotte' },
    { value: 'MX', numeric: '484', text: 'Mexico' },
    { value: 'FM', numeric: '583', text: 'Federated States of Micronesia' },
    { value: 'MD', numeric: '498', text: 'Republic of Moldova' },
    { value: 'MC', numeric: '492', text: 'Monaco' },
    { value: 'MN', numeric: '496', text: 'Mongolia' },
    { value: 'ME', numeric: '499', text: 'Montenegro' },
    { value: 'MS', numeric: '500', text: 'Montserrat' },
    { value: 'MA', numeric: '504', text: 'Morocco' },
    { value: 'MZ', numeric: '508', text: 'Mozambique' },
    { value: 'MM', numeric: '104', text: 'Myanmar' },
    { value: 'NA', numeric: '516', text: 'Namibia' },
    { value: 'NR', numeric: '520', text: 'Nauru' },
    { value: 'NP', numeric: '524', text: 'Nepal' },
    { value: 'NL', numeric: '528', text: 'Netherlands' },
    { value: 'NC', numeric: '540', text: 'New Caledonia' },
    { value: 'NZ', numeric: '554', text: 'New Zealand' },
    { value: 'NI', numeric: '558', text: 'Nicaragua' },
    { value: 'NE', numeric: '562', text: 'Niger' },
    { value: 'NG', numeric: '566', text: 'Nigeria' },
    { value: 'NU', numeric: '570', text: 'Niue' },
    { value: 'NF', numeric: '574', text: 'Norfolk Island' },
    { value: 'MP', numeric: '580', text: 'Northern Mariana Islands' },
    { value: 'NO', numeric: '578', text: 'Norway' },
    { value: 'OM', numeric: '512', text: 'Oman' },
    { value: 'PK', numeric: '586', text: 'Pakistan' },
    { value: 'PW', numeric: '585', text: 'Palau' },
    { value: 'PS', numeric: '275', text: 'State of Palestine' },
    { value: 'PA', numeric: '591', text: 'Panama' },
    { value: 'PG', numeric: '598', text: 'Papua New Guinea' },
    { value: 'PY', numeric: '600', text: 'Paraguay' },
    { value: 'PE', numeric: '604', text: 'Peru' },
    { value: 'PH', numeric: '608', text: 'Philippines' },
    { value: 'PN', numeric: '612', text: 'Pitcairn' },
    { value: 'PL', numeric: '616', text: 'Poland' },
    { value: 'PT', numeric: '620', text: 'Portugal' },
    { value: 'PR', numeric: '630', text: 'Puerto Rico' },
    { value: 'QA', numeric: '634', text: 'Qatar' },
    { value: 'RE', numeric: '638', text: 'Réunion' },
    { value: 'RO', numeric: '642', text: 'Romania' },
    { value: 'RU', numeric: '643', text: 'Russian Federation' },
    { value: 'RW', numeric: '646', text: 'Rwanda' },
    { value: 'BL', numeric: '652', text: 'Saint Barthélemy' },
    {
        value: 'SH',
        numeric: '654',
        text: 'Saint Helena, Ascension and Tristan da Cunha',
    },
    { value: 'KN', numeric: '659', text: 'Saint Kitts and Nevis' },
    { value: 'LC', numeric: '662', text: 'Saint Lucia' },
    { value: 'MF', numeric: '663', text: 'Saint Martin' },
    { value: 'PM', numeric: '666', text: 'Saint Pierre and Miquelon' },
    { value: 'VC', numeric: '670', text: 'Saint Vincent and the Grenadines' },
    { value: 'WS', numeric: '882', text: 'Samoa' },
    { value: 'SM', numeric: '674', text: 'San Marino' },
    { value: 'ST', numeric: '678', text: 'Sao Tome and Principe' },
    { value: 'SA', numeric: '682', text: 'Saudi Arabia' },
    { value: 'SN', numeric: '686', text: 'Senegal' },
    { value: 'RS', numeric: '688', text: 'Serbia' },
    { value: 'SC', numeric: '690', text: 'Seychelles' },
    { value: 'SL', numeric: '694', text: 'Sierra Leone' },
    { value: 'SG', numeric: '702', text: 'Singapore' },
    { value: 'SX', numeric: '534', text: 'Sint Maarten' },
    { value: 'SK', numeric: '703', text: 'Slovakia' },
    { value: 'SI', numeric: '705', text: 'Slovenia' },
    { value: 'SB', numeric: '090', text: 'Solomon Islands' },
    { value: 'SO', numeric: '706', text: 'Somalia' },
    { value: 'ZA', numeric: '710', text: 'South Africa' },
    {
        value: 'GS',
        numeric: '239',
        text: 'South Georgia and the South Sandwich Islands',
    },
    { value: 'SS', numeric: '728', text: 'South Sudan' },
    { value: 'ES', numeric: '724', text: 'Spain' },
    { value: 'LK', numeric: '144', text: 'Sri Lanka' },
    { value: 'SD', numeric: '729', text: 'Sudan' },
    { value: 'SR', numeric: '740', text: 'Suriname' },
    { value: 'SJ', numeric: '744', text: 'Svalbard and Jan Mayen' },
    { value: 'SZ', numeric: '748', text: 'Swaziland' },
    { value: 'SE', numeric: '752', text: 'Sweden' },
    { value: 'CH', numeric: '756', text: 'Switzerland' },
    { value: 'SY', numeric: '760', text: 'Syrian Arab Republic' },
    { value: 'TW', numeric: '158', text: 'Taiwan' },
    { value: 'TJ', numeric: '762', text: 'Tajikistan' },
    { value: 'TZ', numeric: '834', text: 'United Republic of Tanzania' },
    { value: 'TH', numeric: '764', text: 'Thailand' },
    { value: 'TL', numeric: '626', text: 'Timor-Leste' },
    { value: 'TG', numeric: '768', text: 'Togo' },
    { value: 'TK', numeric: '772', text: 'Tokelau' },
    { value: 'TO', numeric: '776', text: 'Tonga' },
    { value: 'TT', numeric: '780', text: 'Trinidad and Tobago' },
    { value: 'TN', numeric: '788', text: 'Tunisia' },
    { value: 'TR', numeric: '792', text: 'Turkey' },
    { value: 'TM', numeric: '795', text: 'Turkmenistan' },
    { value: 'TC', numeric: '796', text: 'Turks and Caicos Islands' },
    { value: 'TV', numeric: '798', text: 'Tuvalu' },
    { value: 'UG', numeric: '800', text: 'Uganda' },
    { value: 'UA', numeric: '804', text: 'Ukraine' },
    { value: 'AE', numeric: '784', text: 'United Arab Emirates' },
    { value: 'GB', numeric: '826', text: 'United Kingdom', local: true },
    { value: 'US', numeric: '840', text: 'United States of America' },
    { value: 'UM', numeric: '581', text: 'United States Minor Outlying Islands' },
    { value: 'UY', numeric: '858', text: 'Uruguay' },
    { value: 'UZ', numeric: '860', text: 'Uzbekistan' },
    { value: 'VU', numeric: '548', text: 'Vanuatu' },
    { value: 'VE', numeric: '862', text: 'Venezuela (Bolivarian Republic of)' },
    { value: 'VN', numeric: '704', text: 'Viet Nam' },
    { value: 'VG', numeric: '092', text: 'Virgin Islands' },
    { value: 'VI', numeric: '850', text: 'Virgin Islands of the United States' },
    { value: 'WF', numeric: '876', text: 'Wallis and Futuna' },
    { value: 'EH', numeric: '732', text: 'Western Sahara' },
    { value: 'YE', numeric: '887', text: 'Yemen' },
    { value: 'ZM', numeric: '894', text: 'Zambia' },
    { value: 'ZW', numeric: '716', text: 'Zimbabwe' },
];
//# sourceMappingURL=CountryField.js.map